module.exports = __webpack_public_path__ + "img/huoshan-2.82a88567.png";